import React from "react";
import { Card } from "../Card";
import { ReactComponent as ScienceBottle } from '../../assets/ScienceBottle.svg'
import { ReactComponent as ArrowRight } from '../../assets/ArrowRight.svg'
import styles from './simulationSuggestion.module.css'

export const SimulationSuggestion = () => {
    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <div className={styles.titleContainer}>
                    <ScienceBottle />
                    <p className={styles.title}>Simulation suggestions</p>
                </div>
                <div className={styles.seeMoreContainer}>
                    <p className={styles.seeMoreText}>See more</p>
                    <ArrowRight />
                </div>
            </div>
            <div className={styles.cardsContainer}>
                <Card className={styles.card}>
                    <div className={styles.cardContent}>
                        <p className={styles.cardTitle}>What if I expanded the expected goals for Q3 revenue's forecast?</p>
                        <div className={styles.cardFooter}>
                            <p className={styles.cardMetric}>
                                <span className={styles.positiveMetric}>+4.3%</span> in YoY
                            </p>
                            <ArrowRight />
                        </div>
                    </div>
                </Card>
                <Card className={styles.card}>
                    <div className={styles.cardContent}>
                        <p className={styles.cardTitle}>What would happen if I cut the sales ops from 'W1 to W4, Dec' due to large demand?</p>
                        <div className={styles.cardFooter}>
                            <p className={styles.cardMetric}>
                                <span className={styles.negativeMetric}>-22%</span> in YoY
                            </p>
                            <ArrowRight />
                        </div>
                    </div>
                </Card>
            </div>
        </div>
    )
}